import { FC, memo } from 'react'
import { Label } from '@cargomart/ui'
import {
  alphabetSymbolsAllow,
  compose,
  FieldFormItem,
  FieldIMask,
  FieldMobilePhone,
  FieldRadio,
  maxChar,
  phoneNumberValid,
  required,
  trimRequired
} from 'forms'
// TODO нельзя импортировать из других модулей
import { FieldCustomerDadataDisableAdd } from 'modules/customer/components/CustomerAddForm/components'
import { OrderItemClient } from 'schema'
import { FieldText } from 'shared/forms'

import { OrderGuestPartnerCreateModalProps } from './types'

const OrderGuestPartnerCreateModal: FC<OrderGuestPartnerCreateModalProps> = (props) => {
  const { storeKey, values } = props
  const fieldClassName = 'w-full [&>*:first-child]:!text-on-surface [&>*]:!text-on-surface-variant'

  return (
    <>
      <FieldFormItem className="inline-flex flex-col gap-y-1" name="type">
        <FieldRadio name="type" validate={required} value={OrderItemClient.type.LEGAL}>
          Юридическое лицо
        </FieldRadio>
        <FieldRadio name="type" validate={required} value={OrderItemClient.type.INDIVIDUAL}>
          Физическое лицо
        </FieldRadio>
      </FieldFormItem>

      <div className="@container">
        <div className="grid grid-cols-1 gap-x-4 @sm:grid-cols-3">
          <FieldFormItem label={<Label className="pt-2">Фамилия</Label>} name="contact.lastname">
            <FieldText
              isShowTooltip
              className={fieldClassName}
              name="contact.lastname"
              validate={compose(trimRequired, alphabetSymbolsAllow, maxChar(100))}
            />
          </FieldFormItem>
          <FieldFormItem label={<Label className="pt-2">Имя</Label>} name="contact.firstname">
            <FieldText
              isShowTooltip
              className={fieldClassName}
              name="contact.firstname"
              validate={compose(trimRequired, alphabetSymbolsAllow, maxChar(100))}
            />
          </FieldFormItem>
          <FieldFormItem label={<Label className="pt-2">Отчество</Label>} name="contact.secondname">
            <FieldText
              isShowTooltip
              className={fieldClassName}
              name="contact.secondname"
              placeholder="При наличии"
              validate={compose(alphabetSymbolsAllow, maxChar(100))}
            />
          </FieldFormItem>
        </div>
        <FieldFormItem label={<Label className="pt-2">Телефон</Label>} name="contact.phone">
          <FieldMobilePhone
            className={fieldClassName}
            maskType="city"
            name="contact.phone"
            validate={compose(required, phoneNumberValid)}
          />
        </FieldFormItem>
        <FieldFormItem label={<Label className="pt-2">Доб. номер</Label>} name="contact.phoneExt">
          <FieldIMask isShowTooltip className={fieldClassName} mask="000000" name="contact.phoneExt" />
          <div className="pt-1 text-body-sm text-on-surface-variant">Необязательно</div>
        </FieldFormItem>
      </div>
      {values?.type === OrderItemClient.type.LEGAL && (
        <>
          <div className="mb-2 mt-6 text-headline-sm">Организация</div>
          <FieldCustomerDadataDisableAdd storeKey={storeKey} validate={required} />
        </>
      )}
    </>
  )
}

export default memo(OrderGuestPartnerCreateModal)
